import TableCell from '@tiptap/extension-table-cell';

export const TimeWebkitTableCellExtension = TableCell;
